<template>
    <amplify-authenticator>
    <div>
        <AdminNavigation></AdminNavigation>
        <div class="container">
            <div class="row">
                <h1 class="mt-3 px-3">Current Subscribers</h1>
            </div>
            <hr/>
            <div class="row">
                <table class="table">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Email</th>
                            <th>Created At</th>
                            <th><button @click.prevent="downloadCSV()" class="btn btn-sm btn-success">Download To CSV</button></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(subscriber, index) in subscribers" :key="subscriber.email" v-if="subscriber.subscribed">
                            <td>{{index+1}}</td>
                            <td>{{subscriber.email}}</td>
                            <td colspan="2">{{subscriber.created}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    <amplify-sign-out></amplify-sign-out>
  </amplify-authenticator>
</template>

<script>
import AdminNavigation from './sub/admin/AdminNavigation';
import { API } from 'aws-amplify';
import * as queries from '../graphql/queries';

export default {
    name: 'AdminDashboard',
    components: {
        AdminNavigation
    },
    mounted: function() {
        API.graphql({ query: queries.listSubscribers }).then(d => {
            this.subscribers  = d.data.listSubscribers.items;
        });
    },
    data: function() {
        return {
            subscribers: []
        }
    },
    methods: {
        downloadCSV() {
            let csvContent = "data:text/csv;charset=utf-8,";

            this.subscribers.forEach(function(e) {
                csvContent += e.email + ",";
            });

            var encodedUri = encodeURI(csvContent);
            window.open(encodedUri);
        }
    }
}
</script>

<!-- Custom Styles -->
<style>

</style>
